import { IPatientClaimRow } from "../../types/claim";

/**
 * CLE-2837 — how many of the patient's claims are NOT the one the modal is showing. One function
 * for the tab header "Patient Claims (N)" and the tab's own summary line, so the two can never
 * disagree. Its own module so the modal tests can stub the tab without re-implementing it.
 */
export const countOtherPatientClaims = (rows: IPatientClaimRow[]): number =>
  rows.filter((row) => !row.isCurrent).length;
